var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8262 11.2734C10.1025 11.2734 8.04185 11.2734 4.43702 11.2734C2.62484 11.2734 1.1543 12.7425 1.1543 14.5547V33.1484C1.1543 34.9606 2.62336 36.4297 4.43555 36.4297H23.0293C24.8415 36.4297 26.3105 34.9606 26.3105 33.1484V21.8884",
    stroke: "#209DB6",
    strokeWidth: 2.1875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52 29.08C7.296 29.08 7.12 29.0107 6.992 28.872C6.864 28.7333 6.8 28.5627 6.8 28.36C6.8 28.2747 6.82667 28.168 6.88 28.04L10.96 18.408C11.0347 18.2373 11.1467 18.088 11.296 17.96C11.456 17.8213 11.6533 17.752 11.888 17.752H12.048C12.2933 17.752 12.4907 17.8213 12.64 17.96C12.7893 18.088 12.9013 18.2373 12.976 18.408L17.056 28.04C17.1093 28.168 17.136 28.2747 17.136 28.36C17.136 28.5627 17.072 28.7333 16.944 28.872C16.816 29.0107 16.64 29.08 16.416 29.08C16.0853 29.08 15.856 28.9307 15.728 28.632L14.688 26.136H9.248L8.208 28.632C8.08 28.9307 7.85067 29.08 7.52 29.08ZM9.808 24.808H14.128L11.968 19.608L9.808 24.808ZM20.2095 29.08C20.0068 29.08 19.8362 29.0107 19.6975 28.872C19.5588 28.7333 19.4895 28.5627 19.4895 28.36V18.488C19.4895 18.2853 19.5588 18.1147 19.6975 17.976C19.8362 17.8267 20.0068 17.752 20.2095 17.752C20.4122 17.752 20.5828 17.8267 20.7215 17.976C20.8708 18.1147 20.9455 18.2853 20.9455 18.488V28.36C20.9455 28.5627 20.8708 28.7333 20.7215 28.872C20.5828 29.0107 20.4122 29.08 20.2095 29.08Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5042 9.73751C29.902 8.63388 27.9546 6.31774 26.4262 0.4664C26.3971 0.354623 26.2334 0.356861 26.207 0.469333C24.8422 6.28531 22.6306 8.31857 16.9916 9.73011C16.8759 9.75906 16.8816 9.93078 16.9987 9.95287C22.9201 11.0691 24.9055 13.3308 26.1997 19.1832C26.2253 19.2992 26.3957 19.2986 26.4213 19.1826C27.7708 13.0678 29.8681 10.9826 35.5025 9.96769C35.6242 9.94577 35.6255 9.76141 35.5042 9.73751Z",
    fill: "url(#paint0_linear_454_16713)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_16713",
    x1: 22.5767,
    y1: 5.44471,
    x2: 30.3838,
    y2: 14.2701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764423,
    stopColor: "#007289"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.3ad8b6a3c3655cd88327e91856f5d4d2.svg";
export { ForwardRef as ReactComponent };